import React, { useState } from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/login/login.js';
import ProtectedRoute from './pages/protectedRoute/protectedRoute.js';
import { LoginProvider } from './context/loginContext.js';
import MainLayout from './pages/layout/layout.js';
import { ConfigProvider } from 'antd';
// Administrador
import CHomeAdministrador from './pages/administrador/home/home-administrador.js';
import EmpresaSelection from './pages/administrador/seleccionar-empresa/selec-empresa-administrador.js';
import CCuentaAdministrador from './pages/administrador/cuentas/cuenta-administrador.js';
import CPlanCuentas from './pages/administrador/plan-cuenta/plan-cuenta-administrador.js';
import CCentroCostos from './pages/administrador/centro-costos/centro-costo-administrador.js';
import CTiposComprobantesAdministrador from './pages/administrador/tipos-comprobantes/tipos-comprobantes-administrador.js';
import CLocalidadesAdministrador from './pages/administrador/localidad/localidad-administrador.js';
import CNuevoMovimientoAdministrador from './pages/administrador/movimiento/movimiento-administrador.js';
import CListaMovimientosAdministrador from './pages/administrador/movimiento/listado-movimiento-administrador.js';
import ImportarMovimientoAdministrador from './pages/administrador/movimiento/importar-movimiento-administrador.js';
import CPagoAdministrador from './pages/administrador/movimiento/pago/pago-administrador.js';
import CListaPagoAdministrador from './pages/administrador/movimiento/pago/lista-pago-administrador.js';
import CReportesAdministrador from './pages/administrador/reportes/reportes-administrador.js';
import UsuariosAdministrador from './pages/administrador/usuarios/usuarios-administrador.js';

function App() {
  const [themeConfig, setThemeConfig] = useState({
    colorPrimary: '#FB6B48',
    borderRadius: 4,
    Button: {
      colorPrimary: '#FB6B48',
      algorithm: true,
    },
  });

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: themeConfig.colorPrimary,
          borderRadius: themeConfig.borderRadius,
        },
        components: {
          Button: {
            colorPrimary: themeConfig.Button?.colorPrimary,
            algorithm: themeConfig.Button?.algorithm,
          },
        },
      }}
    >
      <LoginProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path="/select-empresa"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout hideNavigation>
                    <EmpresaSelection />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/home-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <CHomeAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/nuevo-movimiento-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <CNuevoMovimientoAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/lista-movimiento-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <CListaMovimientosAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/importar-movimiento-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <ImportarMovimientoAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pago-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <CPagoAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/lista-pago-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <CListaPagoAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cuenta-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <CCuentaAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/plan-cuenta-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <CPlanCuentas />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reportes-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <CReportesAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/centro-costo-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <CCentroCostos />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tipos-comprobantes-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <CTiposComprobantesAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/localidad-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']}>
                  <MainLayout>
                    <CLocalidadesAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/usuarios-administrador"
              element={
                <ProtectedRoute allowedRoles={['Administrador']} allowedUsers={['Santiago2', 'Santiago']}>
                  <MainLayout>
                    <UsuariosAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </LoginProvider>
    </ConfigProvider>
  );
}

export default App;